import { STATUS_TYPE } from '../../../enum';

export interface FindAdminAnalytics {
  timePeriod: string;
  startDate?: string;
  endDate?: string;
}

export interface AdminAnalyticsData {
  overview: {
    totalSales: number;
    previousTotalSales: number;
    salesChangePercent: number | null;
    totalOrders: number;
    previousTotalOrders: number;
    ordersChangePercent: number | null;
    averageOrderValue: number;
    previousAverageOrderValue: number;
    aovChangePercent: number | null;
    totalCustomers: number;
    returningCustomersPercent: number;
    newCustomers: number;
    totalItemsSold: number;
    cancelledOrdersCount: number;
    cancelledOrdersValue: number;
  };
  salesAnalytics: {
    revenue: number;
    orders: number;
    averageOrderValue: number;
    ordersPerPeriod: number;
    growthRate: number | null;
    periodDays: number;
  };
  revenueTrend: {
    current: { date: string; value: number }[];
    previous: { date: string; value: number }[];
  };
  ordersTrend: { date: string; count: number }[];
  topSellingCakes: {
    rank: number;
    id: string;
    name: string;
    quantitySold: number;
    revenue: number;
  }[];
  productAnalytics: {
    topSelling: any[];
    highestRevenue: any[];
    repeatPurchase: any[];
  };
  customerAnalytics: {
    totalCustomers: number;
    periodCustomers?: number;
    newCustomers: number;
    returningCustomers: number;
    returningCustomersPercent: number;
  };
  clvSegments: { segment: string; avg_clv: number; customer_count: number }[];
  topCustomers: {
    customerName: string;
    phoneNumber: string;
    ordersCount: number;
    totalSpending: number;
  }[];
  topCustomersBySpending?: {
    customerName: string;
    phoneNumber: string;
    ordersCount: number;
    totalSpending: number;
  }[];
  topCustomersByOrders?: {
    customerName: string;
    phoneNumber: string;
    ordersCount: number;
    totalSpending: number;
  }[];
  operational: {
    avgPreparationTime: number;
    previousAvgPreparationTime: number;
    prepTimeChangePercent: number | null;
    onTimeDelivery: number;
    previousOnTimeDelivery: number;
    onTimeChangePercent: number | null;
    cancelledOrders: number;
    cancelledPercent: number;
    statusBreakdown: { delivered: number; preparing: number; cancelled: number };
  };
  salesFunnel: {
    cartsCreated: number;
    ordersPlaced: number;
    returningCustomers: number;
  };
}

export interface InitialState {
  data: AdminAnalyticsData | null;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: null,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
